import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';

import { NumberPlateInputComponent } from './numberplate-input.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    NumberPlateInputComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,

    CommonTranslationModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    NumberPlateInputComponent
  ]
})
export class NumberplateInputModule { }
